import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "d-flex justify-space-between" }

import { withDefaults, ref, onMounted, watch } from 'vue';
import { AtomSubTitle, AtomTitle } from '@/components/atoms';

interface IProps {
  height: string;
  max?: number;
  hasPercent?: boolean;
  hasPercentTitle?: boolean;
  hasTitle?: boolean;
  margin1?: boolean;
  title?: string;
  progressColor?: string;
  colorPercent?: string;
  modelValue?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomProgressBar',
  props: {
    height: { default: '10' },
    max: null,
    hasPercent: { type: Boolean, default: true },
    hasPercentTitle: { type: Boolean },
    hasTitle: { type: Boolean, default: false },
    margin1: { type: Boolean },
    title: null,
    progressColor: null,
    colorPercent: null,
    modelValue: null
  },
  setup(__props: any) {

const props = __props as { height: string, max?: number, hasPercent: boolean, hasPercentTitle?: boolean, hasTitle: boolean, margin1?: boolean, title?: string, progressColor?: string, colorPercent?: string, modelValue?: any };

function formatLang(value: number): string {
  return new Intl.NumberFormat('pt-BR').format(value);
}
// const emit = defineEmits<{
//   (e: 'update:modelValue', value: string | number | null): void;
// }>();

const progress = ref(0);
onMounted(() => {
  progress.value = props.modelValue;
});

watch(
  () => props.modelValue,
  () => {
    progress.value = props.modelValue;
  }
);
onMounted(() => {
  progress.value = props.modelValue;
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (props.hasTitle)
          ? (_openBlock(), _createBlock(_unref(AtomTitle), {
              key: 0,
              "no-margin": "",
              title: props.title ?? '',
              classes: ['text-sm']
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (props.hasTitle)
          ? (_openBlock(), _createBlock(_unref(AtomSubTitle), {
              key: 1,
              noMargin: "",
              text: props.hasPercentTitle ? `${formatLang(progress.value)}%` : formatLang(progress.value) ?? ''
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_progress_linear, {
        color: __props.progressColor,
        class: _normalizeClass(["flex-1", {'my-2': props.margin1, 'my-4': !props.margin1}]),
        modelValue: progress.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((progress).value = $event)),
        height: __props.height,
        max: props.max ?? 100,
        rounded: ""
      }, null, 8, ["color", "class", "modelValue", "height", "max"])
    ]),
    (props.hasPercent)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          style: _normalizeStyle({ color: props.colorPercent }),
          class: "ms-4 text-xs font-500"
        }, _toDisplayString(Math.ceil(progress.value)) + "% ", 5))
      : _createCommentVNode("", true)
  ]))
}
}

})